<template>
  <div class="certificate-page">
    <div class="header-bar">
      <van-icon name="arrow-left" class="back-icon" @click="goBack" />
      <h1 class="page-title">证书查询</h1>
    </div>

    <div class="content-area">
      <van-loading v-if="loading" size="24px" class="loading-indicator" />

      <div
        v-else-if="certificateData"
        class="certificate-wrapper"
        ref="certificateWrapper"
      >
        <div class="certificate-bg">
          <img src="@/assets/client/bg_certificate.jpg" alt="证书背景" />

          <div class="field cert-no">
            <span>{{ certificateData.certNo || placeholderText }}</span>
          </div>
          <div class="field person-name">
            <span>{{ certificateData.personName || placeholderText }}</span>
          </div>
          <div class="field id-card">
            <span>{{ certificateData.idCard || placeholderText }}</span>
          </div>
          <div class="field project">
            <span>{{ certificateData.cunChuXiangMu || placeholderText }}</span>
          </div>
          <div class="field level">
            <span>{{ certificateData.cunChuJiBie || placeholderText }}</span>
          </div>
          <div class="field location">
            <span>{{ certificateData.certNo || placeholderText }}</span>
          </div>
          <!-- <div class="field result">
            <span>{{
              (certificateData.zhiJianJieGuo) ||
              placeholderText
            }}</span>
          </div> -->
          <div class="field freeze-date">
            <span>{{ certificateData.dongCunRiQi || placeholderText }}</span>
          </div>
          <div class="field duration">
            <span>{{ certificateData.chuCunNianXian || placeholderText }}</span>
          </div>
          <div class="field expire-date">
            <span>{{ certificateData.expireTime || placeholderText }}</span>
          </div>

          <!-- <div class="signature-area">
            <img
              v-if="certificateData.signImg"
              :src="certificateData.signImg"
              alt="签字图片"
            />
            <span v-else>{{ placeholderText }}</span>
          </div> -->
        </div>
      </div>

      <div v-else class="empty-content">
        <van-empty :description="emptyMessage" />
      </div>

      <!-- 下载证书按钮 -->
      <div v-if="certificateData" class="download-section">
        <van-button
          round
          type="primary"
          class="download-btn"
          :loading="downloading"
          :disabled="downloading"
          @click="downloadCertificate"
        >
          下载证书
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { onSelectCertXinWeiLai } from "@/api/client";
import html2canvas from "html2canvas";

export default {
  name: "CertificateQuery",
  data() {
    return {
      loading: false,
      certificateData: null,
      personPrivilgeId: this.$route.query.personPrivilgeId || "",
      placeholderText: "-",
      downloading: false,
    };
  },
  mounted() {
    this.loadCertificate();
  },
  watch: {
    "$route.query.personPrivilgeId"(val) {
      this.personPrivilgeId = val || "";
      this.loadCertificate();
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async loadCertificate() {
      if (!this.personPrivilgeId) {
        this.certificateData = null;
        return;
      }
      this.loading = true;
      this.certificateData = null;
      try {
        const res = await onSelectCertXinWeiLai({
          personPrivilgeId: this.personPrivilgeId,
        });
        if (res.code === 200) {
          this.certificateData = res.data || null;
        } else {
          this.certificateData = null;
          this.$toast(res.msg || "查询失败");
        }
      } catch (error) {
        console.error("查询证书失败", error);
        this.certificateData = null;
        this.$toast("查询失败");
      } finally {
        this.loading = false;
      }
    },
    async downloadCertificate() {
      if (this.downloading || !this.certificateData) {
        return;
      }

      this.downloading = true;
      const loadingToast = this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: "生成图片中...",
      });

      try {
        // 等待元素渲染完成
        await this.$nextTick();

        const wrapper = this.$refs.certificateWrapper;
        if (!wrapper) {
          this.$toast("证书内容未找到");
          return;
        }

        // 使用 html2canvas 将 DOM 转换为 canvas
        const canvas = await html2canvas(wrapper, {
          backgroundColor: "#ffffff",
          scale: 2, // 提高清晰度
          useCORS: true, // 允许跨域图片
          logging: false, // 关闭日志
          width: wrapper.offsetWidth,
          height: wrapper.offsetHeight,
        });

        // 将 canvas 转换为图片并下载
        canvas.toBlob((blob) => {
          if (!blob) {
            this.$toast("生成图片失败");
            return;
          }

          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;

          // 生成文件名（使用证书编号或当前时间）
          const certNo = this.certificateData.certNo || "certificate";
          const fileName = `证书_${certNo}_${Date.now()}.png`;
          link.download = fileName;

          // 触发下载
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // 释放 URL 对象
          setTimeout(() => {
            URL.revokeObjectURL(url);
          }, 100);

          this.$toast("证书下载成功");
        }, "image/png");
      } catch (error) {
        console.error("下载证书失败:", error);
        this.$toast("下载失败，请稍后重试");
      } finally {
        loadingToast.clear();
        this.downloading = false;
      }
    },
  },
  computed: {
    emptyMessage() {
      if (!this.personPrivilgeId) {
        return "暂无证书信息";
      }
      return "暂无证书数据";
    },
  },
};
</script>

<style scoped lang="less">
.certificate-page {
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.header-bar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.back-icon {
  position: absolute;
  left: 16px;
  font-size: 20px;
  color: #333;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.content-area {
  flex: 1;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
}

.loading-indicator {
  margin: 40px auto;
}

.certificate-wrapper {
  display: flex;
  justify-content: center;
}

.certificate-bg {
  position: relative;
  width: 100%;
  max-width: 360px;
}

.certificate-bg img {
  display: block;
  width: 100%;
  height: auto;
}

.certificate-bg .field {
  position: absolute;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.field span {
  display: inline-block;
  min-width: 150px;
}

.cert-no {
  top: 48px;
  left: 125px;
}

.person-name {
  top: 123px;
  left: 150px;
}

.id-card {
  top: 148px;
  left: 150px;
}

.project {
  top: 171px;
  left: 150px;
}

.level {
  top: 195px;
  left: 150px;
}

.location {
  top: 219px;
  left: 150px;
}

.result {
  top: 243px;
  left: 150px;
}

.freeze-date {
  top: 242px;
  left: 150px;
}

.duration {
  top: 265px;
  left: 150px;
}

.expire-date {
  top: 290px;
  left: 150px;
}

.signature-area {
  position: absolute;
  bottom: 84px;
  right: 76px;
  width: 150px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.signature-area img {
  max-width: 100%;
  max-height: 100%;
}

.empty-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 下载按钮区域 */
.download-section {
  padding: 20px;
  background: #fff;
}

.download-btn {
  width: 100%;
  max-width: 360px;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
</style>
